import { useQueries } from "@tanstack/react-query";
import { actionUpdate } from "../services/http-service";
import { IUpdateActionRequest } from "../interfaces/IUpdateActionRequest";

export const useUpdateAction = ({
  updateActionRequest,
  enabled,
}: {
  updateActionRequest: IUpdateActionRequest[];
  enabled: boolean;
}) => {
  const queries = updateActionRequest?.map((request) => {
    return {
      queryKey: ["actionUpdate", request.idList],
      queryFn: async () => await actionUpdate({ actionUpdateData: request }),
      enabled: enabled,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      staleTime: 0,
      cacheTime: 0,
    };
  });
  const actionUpdates = useQueries({ queries: queries });

  const errorFetchingActionUpdate = Boolean(actionUpdates.length) && actionUpdates.some((item) => item.isError === true);
  const successfullUpdatedAction = Boolean(actionUpdates.length) && actionUpdates.every((result) => result.isSuccess);
  const fetchingActionUpdate = Boolean(actionUpdates.length) && actionUpdates.some((item) => item.isFetching === true);
  const updateActionResponseData = actionUpdates[0]?.data?.data;

  return {
    fetchingActionUpdate,
    errorFetchingActionUpdate,
    successfullUpdatedAction,
    updateActionResponseData,
  };
};
